import { Component, OnInit } from '@angular/core';

import { MenuItemService } from './pages-menu';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  template: `
    <ngx-one-column-layout>
      <nb-menu [items]="menu"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
  `,
})
export class PagesComponent implements OnInit {
  
  public href: string = "";
  menu = [];
  // menu = [];
  
  constructor(private router: Router, private menuItemService: MenuItemService, private authService: AuthService,){
    
    if(this.authService.token !== undefined && this.authService.token !== null)
    this.menu = menuItemService.getMenuItems();

  }
  
  ngOnInit(){
  
    /* this.href = this.router.url;
    console.log(this.router.url);
    if(this.href ==="/login"){
      this.menu = [];
     
    }else{
    //  setTimeout(() => {
    //    window.location.reload();
    //  }, 1000);
    } */
  }
}
